import apiClient from '../axios.js';

const BASE = '/line/ai-creative';

export const aiCreativeService = {
  async getQuota() {
    return apiClient.get(`${BASE}/quota`);
  },

  async listUsageLogs(params = {}) {
    return apiClient.get(`${BASE}/usage-logs`, { params });
  },

  async generateRichMenuImage(payload) {
    return apiClient.post(`${BASE}/rich-menu/generate-image`, payload, {
      timeout: 120000,
    });
  },

  async listTopupPackages() {
    return apiClient.get(`${BASE}/topup-packages`);
  },

  async createTopupOrder(packageCode) {
    return apiClient.post(`${BASE}/topup-orders`, { packageCode });
  },

  async listTopupOrders(params = {}) {
    return apiClient.get(`${BASE}/topup-orders`, { params });
  },

  async devCompleteTopupOrder(orderId) {
    return apiClient.post(`${BASE}/topup-orders/${orderId}/dev-complete`);
  },
};

export const AI_CREATIVE_STYLES = [
  { value: 'minimal', label: '簡約' },
  { value: 'festival', label: '節慶' },
  { value: 'cute', label: '可愛' },
  { value: 'elegant', label: '典雅' },
  { value: 'modern', label: '現代' },
];
